// VRG-716 — the commerce-platform field (Create demo → Review, GTM → Sales companies), as the
// platform shows it.
//
// The value list and labels are NOT here: they are `COMMERCE_PLATFORMS` /
// `COMMERCE_PLATFORM_LABELS` in @repo/types, the same list the API validates and migration 0160's
// CHECK enforces. This file only adapts them to the platform's controls.
import {
  COMMERCE_PLATFORM_LABELS,
  COMMERCE_PLATFORMS,
  isCommercePlatform,
  type CommercePlatform,
  type CommercePlatformSource,
} from '@repo/types'

import type { SelectItem } from 'components/input/fields/SelectField'

/** What a company nobody has looked at reads as. Distinct from the `unknown` VALUE ("we could not tell"). */
export const NOT_SET_LABEL = 'Not set'

/** Tolerant on purpose: a filter drawer hands renderers the facet LABEL, not the key. */
export const commercePlatformDisplay = (p: CommercePlatform | string | null | undefined): string =>
  isCommercePlatform(p) ? COMMERCE_PLATFORM_LABELS[p] : typeof p === 'string' && p ? p : NOT_SET_LABEL

export const COMMERCE_PLATFORM_OPTIONS: SelectItem[] = COMMERCE_PLATFORMS.map((p) => ({ value: p, label: COMMERCE_PLATFORM_LABELS[p] }))

/** For a picker: "Not set" first (the SelectField value '' clears it), then the platforms. */
export const COMMERCE_PLATFORM_PICKER_OPTIONS: SelectItem[] = [{ value: '', label: NOT_SET_LABEL }, ...COMMERCE_PLATFORM_OPTIONS]

/** "Detected" / "Set by hand" — the provenance line under the value. */
export const commercePlatformSourceLabel = (s: CommercePlatformSource | null | undefined): string =>
  s === 'manual' ? 'Set by hand' : s === 'detected' ? 'Detected from the site' : ''
